export { addBreadcrumb, captureException, captureEvent, captureMessage, configureScope, setContext, setExtra, setExtras, setTag, setTags, setUser, withScope, } from '@sentry/minimal';
export { addGlobalEventProcessor, getCurrentHub, getHubFromCarrier, Hub, Scope } from '@sentry/hub';
export { API } from './api';
export { BaseClient } from './baseclient';
export { BaseBackend } from './basebackend';
export { initAndBind } from './sdk';
export { NoopTransport } from './transports/noop';
import * as Integrations from './integrations';
export { Integrations };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/esm/index.js
// module id = 5
// module chunks = 0